<template>
  <div class="navbar" :class='device=="mobile"?"mobile":""'>
    <div class='wrap'>
      <div class='navbar-left'>
        <span class='title'>{{ title }}</span>
        <el-button v-if='device!="mobile"' class='home-btn' type="primary" :size='device!="mobile"?"medium":"mini"' icon="el-icon-s-home" circle @click="$router.replace('/')"></el-button>
      </div>
      <el-input v-if='device!="mobile"' class="navbar-right" :placeholder="placeholder" clearable v-model='key' @keyup.enter.native='searchFn'>
        <el-select v-model="select" slot="prepend" placeholder="请选择搜索类型" style='width: 150px;color: #333;'>
          <el-option v-for='item in selectArr' :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-button type='primary' slot="append" icon="el-icon-search" @click='searchFn'>搜索</el-button>
      </el-input>
      <div v-else class='btn-box'>
        <el-button type="primary" :size='device!="mobile"?"medium":"mini"' icon="el-icon-search" circle @click="centerDialogVisible=true"></el-button>
        <el-button type="primary" :size='device!="mobile"?"medium":"mini"' icon="el-icon-s-home" circle @click="$router.replace('/')"></el-button>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      :show-close='false'
      top='30vh'
      width="90%"
      modal
      center>
      <div class='dialog-inner'>
        <div class='dialog-inner_radioBox'>
          <div class="dialog-inner_radio" v-for="item in selectArr" :class='item.value == select?"check":""' @click='select=item.value'>{{ item.label.substring(0, 4) }}</div>
        </div>
        <div class='dialog-inner_inputBox'>
          <input class='dialog-inner_input' type="text" :value='key' :placeholder="placeholder" @input="inputChange">
          <i v-if='key' class="el-icon-circle-close" @click='key=""' style='font-size: 19px;'></i>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false" size='medium'>取 消</el-button>
          <el-button type="primary" @click="centerDialogVisible=false;searchFn()" size='medium'>搜 索</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MessageBox, Message } from 'element-ui'
import setting from '@/settings.js'
import { validateSearchVal } from '@/utils/validate'


export default {
  name: 'NavBar',
  data() {
    return {
      centerDialogVisible: false,
      title: setting.title,
      placeholder: '支持搜索主资产编号/交易哈希/钱包地址/区块高度',
      selectArr: [{
        label: '资产发布信息',
        value: 'assets',
        placeholder: '请输入主资产编号'
      },{
        label: '交易哈希信息',
        value: 'trade',
        placeholder: '请输入交易哈希'
      },{
        label: '用户钱包地址',
        value: 'address',
        placeholder: '请输入钱包地址'
      },{
        label: '区块高度信息',
        value: 'block',
        placeholder: '请输入区块高度'
      }],
      select: this.$route.name || '',
      key: this.$route.query.key || ''
    }
  },
  components: {
   
  },
  created() {
    if(!this.$route.query.key) {
      this.$router.replace({
        path: '/',
      })
    }
  },
  computed: {
    ...mapGetters([
      'device'
    ])
  },
  watch: {
    select: {
      handler(val) {
        this.selectArr.forEach(item => {
          if(item.value == val) {
            this.placeholder = item.placeholder
          }
        })
      },
      immediate: true
    }
  },
  methods: {
    inputChange(e) {
      this.key = e.target.value
    },
    // resetLocation: _.debounce(function() {
    //   this.$router.push({
    //     name: this.select,
    //     query: {
    //       key: this.key,
    //       t: Date.parse(new Date)
    //     }
    //   })
    // }, 500, {
    //   leading: true
    // }),
    searchFn() {
      if(!this.key) {
        MessageBox.confirm('搜索内容不能为空', '', {
          confirmButtonText: '确定',
          showCancelButton: false,
          // type: 'info',
          center: true
        })
        return;
      }
      if (!validateSearchVal(this.key)) {
        MessageBox.confirm("搜索内容格式不正确", "", {
          confirmButtonText: "确定",
          showCancelButton: false,
          // type: 'info',
          center: true,
        }).then();
        return;
      }
      if(!this.select) {
        MessageBox.confirm('请选择搜索类型', '', {
          confirmButtonText: '确定',
          showCancelButton: false,
          // type: 'info',
          center: true
        })
        return;
      }
      this.$router.push({
        name: this.select,
        query: {
          key: this.key,
          t: randomString(8)
        }
      })
      // this.resetLocation()
      function randomString(e) {    
        e = e || 32;
        var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
        for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
        return n
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

::v-deep {
  .el-input__inner {
    border: none;
    outline: none;
  }
  .el-input-group__append {
    .el-button {
      border: none;
      background-color: $primaryColor;
      color: #fff;
    }
  }
  .el-dialog__body, .el-dialog__header {
    padding: 0;
  }
}
.navbar {
  width: 100%;
  height: 70px;
  background: $menuBg;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  .wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    padding: 0 20px;
    max-width: 1200px;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    .navbar-left {
      flex: 1;
      display: flex;
      align-items: center;
      .title {
        color: #fff;
        font-size: 24px;
        letter-spacing: 2px;
      }
      .home-btn {
        margin-left: 8%;
      }
    }
    .navbar-right {
      width: 550px;
    }
  }

  &.mobile {
    width: 100%;
    height: 40px;
    box-shadow: 0 1*0.5px 4*0.5px rgba(0,21,41,.08);
    .wrap {
      padding: 0 20*0.5px;
      max-width: auto;
      min-width: auto;
      height: 100%;
      .navbar-left {
        .title {
          font-size: 18px;
          letter-spacing: 2*0.5px;
        }
        .home-btn {
          margin-left: 5%;
        }
      }
      .navbar-right {
        width: 500*0.5px;
      }
    }
  }

  .dialog-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px 10px;
    .dialog-inner_radioBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      border: thin solid rgb(228, 226, 226);
      border-radius: 5px;
      .dialog-inner_radio {
        flex: 1;
        text-align: center;
        font-size: 13px;
        line-height: 13px;
        padding: 10px 0;
        &.check {
          background-color: $primaryColor;
          color: #fff;
          border-color: $primaryColor;
        }
      }
      .dialog-inner_radio + .dialog-inner_radio {
        border-left: thin solid rgb(228, 226, 226);
      }
    }
    .dialog-inner_inputBox {
      position: relative;
      width: 100%;
      .dialog-inner_input {
        margin: 20px 0px;
        padding: 6px 10px;
        width: 100%;
        border: thin solid rgb(228, 226, 226);
        border-radius: 5px;
        font-size: 15px;
        line-height: 20px;
        outline: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        -webkit-appearance:none;
        color: #333;
      }
      >i {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
